import triggers from './triggers';
import listeners from './listeners';

export default { sagas: [...triggers, ...listeners] };
